import { type RatePackage } from './rate-package';

export class CSRData {
  // public RatePackageId?: string = '';
  public AGLQuestion1?: string = '';
  public AGLQuestion2?: string = '';
  public AGLQuestion3?: string = '';
  public AGLResponse1?: string = '';
  public AGLResponse2?: string = '';
  public AGLResponse3?: string = '';
  public Address?: string = '';
  public AddressLine2?: string = '';
  public AptNum?: string = '';
  public BudgetBilling?: string = '';
  public City?: string = '';
  public ClientAwarePotentialDelay?: string = '';
  public ClosingDate?: string = '';
  public CoApplicantDOB?: string = '';
  public CoApplicantEmail?: string = '';
  public CoApplicantFirst?: string = '';
  public CoApplicantLast?: string = '';
  public CoApplicantMiddleInitial?: string = '';
  public CoApplicantSSN?: string = '';
  public DOB?: string = '';
  public Email?: string = '';
  public LastName?: string = '';
  public MailingAddress?: string = '';
  public MailingCity?: string = '';
  public MailingState?: string = '';
  public MailingZip?: string = '';
  public MiddleInitial?: string = '';
  public Phone?: string = '';
  public LandPhone?: string = '';
  public PrimaryPhone?: string = '';
  public PreferredConnectionDate?: string = '';
  public PreviouslyServiced?: string = '';
  public RatePerTherm?: string = '';
  public RatePlan?: string = '';
  public SSN?: string = '';
  public Service?: string = '';
  public SpecialInstructions?: string = '';
  public State?: string = '';
  public TaxID?: string = '';
  public Zip?: string = '';
  public ActionMethod?: string = 'CM-GSCHANGESERVICE';
  public OrderType?: string = 'RATECHANGE';
  public CreateProcessFlow?: string = 'N';
  public CreateToDo?: string = 'N';
  public CsrId?: string = '';
  public Activate?: string = 'Y';
  public CustomerClass?: string = 'RES';
  public SalesChannel?: string = 'MOBILE';
  public EnrollmentType?: string = 'MS';
  public Seasonal?: string = '';
  public SalesforceId?: string = '';
  public Sequence?: string = '1';
  public Paperless?: string = '';
  public ActionFlag?: string = 'C1AD';
  public MainCustomer?: string = '';
  public FinanciallyResponsible?: string = '';
  public AccountRelationshipType?: string = '';
  public ShouldReceiveBill?: string = '';
  public BillFormat?: string = '';
  public NumberOfBillCopies?: string = '';
  public ReceiveNotification?: string = '';
  public BillAddressSource?: string = '';
  public MainPersonId?: string = '';
  public PersonSequence?: string = '1';
  public PremiseSequence?: string = '1';
  public PremiseId?: string = '';
  public AddressOption?: string = '';
  public ContractSequence?: string = '1';
  public ContractType?: string = '';
  public ContractAction?: string = '';
  public ContractDate?: string = '';
  public Products?: Product[];
  public Operands?: RateOperand[];
  public PromoCode?: string = '';
  public PromoCodeValue?: string = '';
  public ReferredBy?: string = '';
  public DiscountAmount?: string = '';
  public OppAmount?: string = '';
  public CustomerServiceFee?: string = '';
  public CancellationFee?: string = '';
  public AglAccountNumber?: string = '';
  public BudgetBillAmount?: string = '';
  public IncentiveDescription?: string = '';
  public IncentiveTypeDescription?: string = '';
  public Incentives?: Incentive[];
  public LocationSequence?: string = '';
  public LocationAction?: string = '';
  public ServiceLocationAction?: string = '';
  public LDCNumber?: string = '';
  public Distributor?: string = '';
  public Market?: string = '';
  public LocationCharacteristicName?: string = '';
  public CountryCode?: string = '';
  public OverrideAddress?: string = '';
  public CreditCheckDate?: string = '';
  public CreditBusinessScore?: string = '';
  public BusinessFailureScore?: string = '';
  public CreditDecision?: string = '';
  public CreditScore?: string = '';
  public CreditDOB?: string = '';
  public CreditIdentifier?: string = '';
  public CreditTransactionId?: string = '';
  public BureaueCreditDescision?: string = '';
  public SaId?: string = '';
  public GSAccountNumber?: string = '';
  public ProductAction?: string = '';
  public FirstName?: string = '';
  public Version?: string = '';
  public RelatedProductSequence?: string = '';
  public CRDCCode?: string = '';
  public CRDValue?: string = '';
  public IncentiveType?: string = '';
  public IncentiveValue?: string = '';
  public IsRenewal?: string = 'N';
  public AptTimeSlot?: string = '';
  public CustomerType?: string = '';
  public PremiseAction?: string = '';
  public GCMANameMatch?: string = '';
  public BusinessName?: string = '';
  public BusinessPhone?: string = '';
  public SaturdayIfAvailable?: boolean;
  public KMI?: boolean;
  public MobilePhone?: string = '';
  public RatePackageId?: string = '';
  public BudgetPlan?: string = '';
  public RatePackages?: RatePackage[] = [];
  public DiscountCode?: string = '';
}

export class Product {
  public ProductSequence?: string;
  public PreferredConnectionDate?: string;
  public ProductAction?: string;
  public Version?: string;
  public RelatedProductSequence?: string;
  public SaId?: string;
  public ProductId?: string;
}

export class RateOperand {
  public Code?: string;
  public Value?: string;
}

export class SSMRateOperand {
  public OperandCode?: string;
  public OperandValue?: string;
}

export class Incentive {
  public Type?: string;
  public Value?: string;
}
